import "./App.css";
import { Routes, Route } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Landing from "./Pages/Landing";
import Login from "./Pages/Login";
import Home from "./Pages/Home";
import {
  AuthRoute,
  EnsureHasProfile,
  EnsureSubscriptionFeature,
  EnsureVerified,
  GuestRoute,
  RedirectIfVerified
} from "./middlewares";
import NoMatch from "./Pages/NoMatch";

import EngineConfigStack from "./Routes/EngineConfigStack";
import ApiGenerationStack from "./Routes/ApiGenerationStack";
import MyApiStack from "./Routes/MyApiStack";
import GetToken from "./Routes/GetTokenStack";
import Subscription from "./Pages/Subscription";
import { ToolTipContextProvider } from "./Context/ToolTipContext";
import Profile from "./Pages/Profile";
import { SidebarContextProvider } from "./Context/SidebarContext";
import { LanguageContextProvider } from "./Context/LanguageContext";
import Register from "./Pages/Register";
import Verify from "./Pages/Verification";
import ApiView from "./Pages/ApiView";
import ForgotPassword from "./Pages/ForgotPassword";
import { ApiGenerationContextProvider } from "./Context/ApiGenerationContext";
import { MyApiContextProvider } from "./Context/MyApiContext";
import { EngineConfigContextProvider } from "./Context/EngineConfigContext";
import { SubscriptionAccessProvider } from "./Context/SubscriptionAccessContext";
import Payment from "./Pages/Payment";
import HelpCenter from "./Pages/HelpCenter";
import Invoices from "./Pages/Invoices";
import ManageCredits from "./Pages/ManageCredits";

function App() {
  return (
    <LanguageContextProvider>
      <ToolTipContextProvider>
        <SidebarContextProvider>
          <SubscriptionAccessProvider>
            <EngineConfigContextProvider>
              <MyApiContextProvider>
                <ApiGenerationContextProvider>
                  <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/" element={<GuestRoute />}>
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/forgot-password" element={<ForgotPassword />} />
                    </Route>
                    <Route path="/" element={<RedirectIfVerified />}>
                      <Route path="/verify" element={<Verify />} />
                    </Route>
                    <Route path="/" element={<AuthRoute />}>
                      <Route path="/" element={<EnsureVerified />}>
                        <Route path="/payment" element={<Payment />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/help-center" element={<HelpCenter />} />
                        <Route path="/" element={<EnsureHasProfile />}>
                          <Route path="/home" element={<Home />} />
                          <Route path="/my-apis/*" element={<MyApiStack />} />
                          <Route path="/subscription" element={<Subscription />} />
                          <Route path="/billing/invoices" element={<Invoices />} />
                          <Route path="/billing/manage-credits" element={<ManageCredits />} />
                          <Route path="/" element={<EnsureSubscriptionFeature />}>
                            <Route path="/engine-config/*" element={<EngineConfigStack />} />
                            <Route path="/api-generator/*" element={<ApiGenerationStack />} />
                            <Route path="/api-view" element={<ApiView />} />
                            <Route path="/gettoken/*" element={<GetToken />} />
                          </Route>
                        </Route>
                      </Route>
                    </Route>
                    <Route path="*" element={<NoMatch />} />
                  </Routes>
                </ApiGenerationContextProvider>
              </MyApiContextProvider>
            </EngineConfigContextProvider>
          </SubscriptionAccessProvider>
        </SidebarContextProvider>
      </ToolTipContextProvider>
    </LanguageContextProvider>
  );
}

export default withTranslation("common")(App);
